module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "f-nav-static"
  }, [_c('div', {
    staticClass: "nav-tab"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dropDown),
      expression: "!dropDown"
    }],
    staticClass: "nav-horizontal",
    class: {
      'show-icon': _vm.hasDropDown
    }
  }, [_c('ul', {
    staticClass: "list-wrap transition"
  }, _vm._l((_vm.listItem), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "list",
      class: {
        'active': item.active
      },
      attrs: {
        "data-type": item.type,
        "data-id": item.id
      },
      on: {
        "click": _vm.onListClickHandle
      }
    }, [_c('span', [_vm._v(_vm._s(item.text))])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropDown),
      expression: "dropDown"
    }],
    staticClass: "nav-title"
  }, [_vm._v("全部分类")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasDropDown),
      expression: "hasDropDown"
    }],
    staticClass: "nav-icon",
    class: {
      'rotate': _vm.dropDown
    },
    on: {
      "click": _vm.onToggleHandle
    }
  }, [_c('img', {
    attrs: {
      "src": "//cdn.upin.com/mfanhuan/images/home/icon-tab-order.png"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropDown),
      expression: "dropDown"
    }],
    staticClass: "nav-dropdown"
  }, _vm._l((_vm.rowlist), function(row, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('ul', {
      staticClass: "list-wrap"
    }, _vm._l((row), function(item) {
      return _c('li', {
        key: item.id,
        staticClass: "list",
        class: {
          'active': item.active
        },
        attrs: {
          "data-type": item.type,
          "data-id": item.id
        },
        on: {
          "click": _vm.onListClickHandle
        }
      }, [_c('span', [_vm._v(_vm._s(item.text))])])
    }), 0)])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropDown),
      expression: "dropDown"
    }],
    staticClass: "nav-mask",
    on: {
      "click": _vm.onToggleHandle
    }
  })])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-bad27d10", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-bad27d10!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/nav/nav-static.vue
// module id = 18
// module chunks = 0